<!-- Copyright (c) 2022-2024, NVIDIA CORPORATION & AFFILIATES. All rights reserved. -->

<template>
    <vue-progress-bar class="progress-bar-animated progress-bar-striped" />
</template>
<script>
export default {
    name: 'ProgressBar',
};
</script>
<style lang="scss" scoped>

.progress-bar-animated {
    animation: progress-bar-stripes 1s linear infinite;
}

.progress-bar-striped {
    background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,
        transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,
        hsla(0,0%,100%,.15) 75%,transparent 0,transparent);
    background-size: 1rem 1rem;
}

@keyframes progress-bar-stripes {
    0% {
        background-position: 1rem 0
    }

    to {
        background-position: 0 0
    }
}
</style>
